export const navigationItems = [
    {
        id: 'about',
        title: 'About',
        link: '/about'
    },
    {
        id: 'training',
        title: 'Training',
        link: '/training'
    },
    {
        id: 'order',
        title: 'Order',
        link: '/order'
    },
    {
        id: 'product-specs',
        title: 'Product Specs',
        link: '/product-specs'
    },
    {
        id: 'planogram',
        title: 'Planogram',
        link: '/planogram'
    },
    {
        id: 'best-practices',
        title: 'Best Practices',
        link: '/best-practices'
    },
    {
        id: 'faq',
        title: 'FAQ',
        link: '/faq'
    },
    {
        id: 'support',
        title: 'Support',
        link: '/support'
    },
    {
        id: 'webinar',
        title: 'Webinar',
        link: '/webinar'
    }
];
